var _path, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInvoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 39,
  height: 47,
  viewBox: "0 0 39 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.92676 4C1.92676 2.34315 3.2699 1 4.92676 1H34.0696C35.7265 1 37.0696 2.34315 37.0696 4V45.6283L28.9671 43.0244L28.6611 43.9764L28.9671 43.0244C28.5255 42.8825 28.0483 42.8984 27.6172 43.0696L20.3988 45.9352L11.7659 43.0221C11.3691 42.8882 10.9403 42.8823 10.5399 43.0051L1.92676 45.6473L1.92676 4Z",
  stroke: "currentColor",
  strokeWidth: 2
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 7.95312,
  y: 15,
  width: 21.0811,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 7.95312,
  y: 20,
  width: 18.0695,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 7.95312,
  y: 25,
  width: 12.0463,
  height: 2,
  rx: 1,
  fill: "currentColor"
})));
export { SvgInvoice as ReactComponent };